import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Modal, modalBtnPrimary, modalBtnSecondary } from "../Modal";
import { CATEGORY_LABELS } from "./shared";

const EMPTY = { name: "", category: "elektro", manufacturer: "", model: "", serial_number: "", purchase_date: "", price: "", warranty_until: "", next_inspection: "", inspection_interval_months: 12, status: "k_dispozici", notes: "", rental_type: "" };
const inp = "w-full min-h-[44px] px-3 py-2 border border-slate-300 text-sm rounded-sm bg-white";

export function ToolForm({ initial, onClose, onSaved }) {
    const [f, setF] = useState({ ...EMPTY, ...(initial || {}), price: initial?.price ?? "", rental_type: initial?.rental_type || "" });
    const [types, setTypes] = useState([]);
    const [busy, setBusy] = useState(false);
    useEffect(() => { api.get("/tools/meta").then((r) => setTypes(r.data.rental_types || [])).catch(() => {}); }, []);
    const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
    const save = async () => {
        if (!f.name.trim()) { toast.error("Zadejte název nářadí"); return; }
        setBusy(true);
        try {
            const body = { ...f, price: f.price === "" ? null : Number(f.price), inspection_interval_months: f.inspection_interval_months ? Number(f.inspection_interval_months) : null,
                purchase_date: f.purchase_date || null, warranty_until: f.warranty_until || null, next_inspection: f.next_inspection || null, rental_type: f.rental_type || null, status: initial ? undefined : f.status };
            const r = initial ? await api.put(`/tools/${initial.id}`, body) : await api.post("/tools", body);
            toast.success(initial ? "Nářadí uloženo" : "Nářadí přidáno");
            onSaved(r.data);
        } catch (e) { toast.error(e.response?.data?.detail || "Uložení selhalo"); }
        finally { setBusy(false); }
    };
    const F = (l, k, type = "text", children = null) => (
        <div><label className="label-eyebrow block mb-1.5">{l}</label>{children || <input type={type} value={f[k] ?? ""} onChange={set(k)} data-testid={`tool-${k}`} className={inp} />}</div>
    );
    return (
        <Modal title={initial ? "Upravit nářadí" : "Nové nářadí"} onClose={onClose} testid="tool-form" size="max-w-2xl"
               footer={<><button onClick={onClose} className={modalBtnSecondary}>Zrušit</button><button onClick={save} disabled={busy} data-testid="tool-save" className={modalBtnPrimary}>{initial ? "Uložit" : "Přidat"}</button></>}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div className="md:col-span-2">{F("Název *", "name")}</div>
                {F("Kategorie", "category", "text", <select value={f.category} onChange={set("category")} data-testid="tool-category" className={inp}>{Object.entries(CATEGORY_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select>)}
                {F("Výrobce", "manufacturer")}
                {F("Model", "model")}
                {F("Výrobní číslo", "serial_number")}
                {F("Datum nákupu", "purchase_date", "date")}
                {F("Pořizovací cena (Kč)", "price", "number")}
                {F("Záruka do", "warranty_until", "date")}
                {F("Příští revize / kontrola", "next_inspection", "date")}
                {F("Interval revize (měsíce)", "inspection_interval_months", "number")}
                {F("Typ půjčovného (porovnání nákup × půjčovné)", "rental_type", "text", <select value={f.rental_type} onChange={set("rental_type")} data-testid="tool-rental-type" className={inp}><option value="">— žádný —</option>{types.map((t) => <option key={t} value={t}>{t}</option>)}</select>)}
                <div className="md:col-span-2">{F("Poznámka", "notes", "text", <textarea value={f.notes} onChange={set("notes")} rows={2} data-testid="tool-notes" className={inp} />)}</div>
            </div>
        </Modal>
    );
}
